import {baseUrl, execute} from "./ApiUtils";


const customDecksUrl = baseUrl + "assets/custom_deck";
const customDeckByIdUrl = baseUrl + "assets/custom_deck/";
const customCardByIdUrl = baseUrl + "assets/custom_card/";
const privateMentorNotesUrl = baseUrl + "assets/mentor_note";
const privateMentorNoteByFieldNumberUrl = baseUrl + "assets/mentor_note/";
const availableMetaphoricCardsUrl = baseUrl + "assets/available_metaphoric_cards";
const availableCustomCardStyles = baseUrl + "assets/available_card_backgrounds"

const customBackgroundPresignedRequestUrl = baseUrl + "assets/presigned_background_upload_request"




export function getAllCustomDecks(successCallBack, errorCallBack) {
    execute(
        () => fetch(customDecksUrl, {
                method: "GET",
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                credentials: "include"
            }
        ), successCallBack, errorCallBack
    )
}

export function createNewCustomDeck(name, withDefaultCards, withDefaultEnCards, successCallBack, errorCallBack) {
    execute(
        () => fetch(customDecksUrl, {
                method: "POST",
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    name: name,
                    with_default_cards_ua: withDefaultCards,
                    with_default_cards_en: withDefaultEnCards,
                }),
                credentials: "include"
            }
        ), successCallBack, errorCallBack
    )
}

export function getCustomDeckById(id, successCallBack, errorCallBack) {
    execute(
        () => fetch(customDeckByIdUrl + id, {
                method: "GET",
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                credentials: "include"
            }
        ), successCallBack, errorCallBack
    )
}

export function postCustomDeckUpdate(deck_id, deck_name, backgroundId, successCallBack, errorCallBack) {
    execute(
        () => fetch(customDeckByIdUrl + deck_id, {
                method: "PATCH",
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    name: deck_name,
                    background_id: backgroundId
                }),
                credentials: "include"
            }
        ), successCallBack, errorCallBack
    )
}

export function deleteCustomDeck(deck_id, successCallBack, errorCallBack) {
    execute(
        () => fetch(customDeckByIdUrl + deck_id, {
                method: "DELETE",
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                credentials: "include"
            }
        ), successCallBack, errorCallBack
    )
}

export function postCustomCardUpdate(card_id, newTitle, newDescription, successCallBack, errorCallBack) {
    execute(
        () => fetch(customCardByIdUrl + card_id, {
                method: "PATCH",
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    title: newTitle,
                    card_text: newDescription
                }),
                credentials: "include"
            }
        ), successCallBack, errorCallBack
    )
}

export function getPrivateNotes(successCallBack, errorCallBack) {
    execute(
        () => fetch(privateMentorNotesUrl, {
                method: "GET",
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                credentials: "include"
            }
        ), successCallBack, errorCallBack
    )
}

export function postPrivateNote(fieldNumber, noteText, successCallBack, errorCallBack) {
    execute(
        () => fetch(privateMentorNoteByFieldNumberUrl + fieldNumber, {
                method: "POST",
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    note_text: noteText,
                }),
                credentials: "include"
            }
        ), successCallBack, errorCallBack
    )
}

export function getAvailableMetaphoricCards(successCallBack, errorCallBack) {
    execute(
        () => fetch(availableMetaphoricCardsUrl, {
                method: "GET",
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                credentials: "include"
            }
        ), successCallBack, errorCallBack
    )
}

export function getAvailableCustomCardStyles(successCallBack, errorCallBack) {
    execute(
        () => fetch(availableCustomCardStyles, {
                method: "GET",
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                credentials: "include"
            }
        ), successCallBack, errorCallBack
    )
}

export function createNewBackground(image_height, image_width, padding_top, padding_left, padding_right, padding_bottom, fontColor, successCallBack, errorCallBack) {
    execute(()=> fetch(availableCustomCardStyles, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            background_image_url: "EMPTY",
            image_height: image_height,
            image_width: image_width,
            padding_top: padding_top,
            padding_left: padding_left,
            padding_right: padding_right,
            padding_bottom: padding_bottom,
            font_color: fontColor
        }),
        credentials: "include"
    }), successCallBack, errorCallBack)
}

export function getCustomBackgroundPresignedUploadRequest(background_id, fileExtension, successCallBack, errorCallBack) {
    execute(() => fetch(customBackgroundPresignedRequestUrl, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            background_id: background_id,
            file_extension: fileExtension
        }),
        credentials: "include"
    }), successCallBack, errorCallBack)
}

export function updateBackgroundImgUrl(bgId, imgUrl, successCallBack, errorCallBack) {
    execute(()=> fetch(availableCustomCardStyles + "/" + bgId, {
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            background_image_url: imgUrl
        }),
        credentials: "include"
    }), successCallBack, errorCallBack)
}